export const STAFF_PERMISSIONS = [
    { key: 'dashboard', label: 'Dashboard', description: 'Business metrics and high-level activity.' },
    { key: 'production', label: 'Production', description: 'Production queue and order workspaces.' },
    { key: 'schedule', label: 'Schedule', description: 'Production schedule and job timing.' },
    { key: 'overview', label: 'Overview', description: 'Production capacity and status overview.' },
    { key: 'maintenance', label: 'Maintenance', description: 'Machine maintenance and service records.' },
    { key: 'customers', label: 'Customers', description: 'Customer profiles and account details.' },
    { key: 'rfqs', label: 'RFQs', description: 'Quote requests awaiting staff review.' },
    { key: 'drafts', label: 'Drafts', description: 'Saved and unfinished quotes.' },
    { key: 'view_pricing', label: 'Job pricing', description: 'Show quoted prices, totals, shipping charges, and cost-entry controls on production jobs.' },
] as const;

export type StaffPermission = (typeof STAFF_PERMISSIONS)[number]['key'];

export const ALL_STAFF_PERMISSIONS: StaffPermission[] = STAFF_PERMISSIONS.map(
    permission => permission.key,
);

// These match the access staff already had before configurable roles were added.
export const DEFAULT_EMPLOYEE_PERMISSIONS: StaffPermission[] = [
    'production',
    'schedule',
    'overview',
    'maintenance',
    'drafts',
    'view_pricing',
];

export interface StaffRole {
    id: string;
    name: string;
    slug: string;
    description: string | null;
    is_system: boolean;
    is_admin: boolean;
}

const PERMISSION_ROUTES: Partial<Record<StaffPermission, string>> = {
    dashboard: '/',
    production: '/production',
    schedule: '/production/schedule',
    overview: '/production/overview',
    maintenance: '/production/maintenance',
    customers: '/admin/customers',
    rfqs: '/admin/requests',
    drafts: '/admin/drafts',
};

export function firstAccessibleStaffPath(permissions: StaffPermission[]) {
    const firstPermission = ALL_STAFF_PERMISSIONS.find(
        permission => permissions.includes(permission) && PERMISSION_ROUTES[permission],
    );
    return firstPermission ? PERMISSION_ROUTES[firstPermission] || null : null;
}

export function defaultPermissionsForLegacyRole(
    role: 'customer' | 'admin' | 'employee' | null,
): StaffPermission[] {
    if (role === 'admin') return ALL_STAFF_PERMISSIONS;
    if (role === 'employee') return DEFAULT_EMPLOYEE_PERMISSIONS;
    return [];
}
